export default __webpack_public_path__ + "static/media/landing-background-mobile.4dd05f1c.jpg";